var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMumbai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.593,
    height: 64.593,
    viewBox: "0 0 64.593 64.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11922",
    "data-name": "Group 11922",
    transform: "translate(-1172.969 163.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20327",
    "data-name": "Path 20327",
    d: "M1248.545-98.438h-60.3a1.052,1.052,0,0,1-.177-.777q0-10.706,0-21.412c0-.831.125-.956.94-.972a2.832,2.832,0,0,1,1.181.1c.339.255.25.632.257.971.023,1.119.044,1.144,1.162,1.081a.816.816,0,0,0,.471-.121c.275-.331.13-.722.146-1.084.035-.806.139-.933.959-.939a2.5,2.5,0,0,1,1.225.124c.316.377.181.83.2,1.253.03.721.059.767.793.765a1.38,1.38,0,0,0,.844-.122c.283-.376.113-.807.145-1.21.05-.635.156-.786.774-.8a2.922,2.922,0,0,1,1.412.119c.3.361.183.8.2,1.2.025.779.047.818.818.813.285,0,.591.069.835-.158a1.172,1.172,0,0,0,.127-.794c-.014-5.36,0-10.72-.015-16.08-.018-7.21.026-14.419.019-21.629a1.376,1.376,0,0,1,.109-.738c.373-.332.833-.21,1.259-.214.452,0,.639-.181.633-.634-.011-.835-.007-1.671,0-2.506a1.169,1.169,0,0,1,.195-.833h2.145a1.172,1.172,0,0,1,.2.837c.007.8.015,1.6,0,2.4-.011.491.151.718.681.735,1.34.043,1.34.063,1.341,1.421,0,2,0,3.993,0,5.989,0,.862.04.906.874.907q10.4.006,20.8,0c.834,0,.873-.045.874-.907,0-2.1,0-4.2,0-6.3,0-.967.127-1.084,1.086-1.112.924-.027.926-.027.929-.981,0-.714,0-1.429,0-2.143a1.173,1.173,0,0,1,.2-.837h2.145a1.162,1.162,0,0,1,.194.83c.006.749,0,1.5,0,2.247,0,.86.024.872.864.893a1.44,1.44,0,0,1,1.015.2,1.7,1.7,0,0,1,.118.924c0,3.277-.008,6.554,0,9.831.037,9.2-.02,18.4,0,27.6,0,.308-.081.635.135.911a1.959,1.959,0,0,0,1.328.119c.342-.03.286-.346.312-.587.049-.464-.12-.958.186-1.389a3.412,3.412,0,0,1,1.67-.105c.393.025.489.311.526.659.048.447-.141.924.155,1.338a2.327,2.327,0,0,0,1.233.1c.384-.009.37-.316.395-.593.042-.469-.123-.967.186-1.4a3.434,3.434,0,0,1,1.671-.1c.393.026.486.314.524.662.048.447-.144.924.158,1.337a2.421,2.421,0,0,0,1.229.1c.294,0,.374-.216.386-.47.015-.313,0-.626.016-.938a.716.716,0,0,1,.234-.619.762.762,0,0,1,.177-.068c1.7-.306,1.966-.086,1.966,1.6q0,10.242,0,20.484C1248.72-99.119,1248.8-98.747,1248.545-98.438Z",
    transform: "translate(-13.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20328",
    "data-name": "Path 20328",
    d: "M1172.969-113.931c4.646,0,9.291,0,13.937.022.556,0,.593-.23.592-.669q-.016-7.631,0-15.261a1.19,1.19,0,0,1,.058-.673c.012.209.035.417.035.625q0,19.093,0,38.186c0,.224.075.461-.067.673-.342-.292-.212-.693-.233-1.054a9.921,9.921,0,0,1,.006-1.062q-.042-3.073,0-6.146c-.035-2.394-.006-4.789-.016-7.183,0-.936-.01-.943-.95-.947-3.046-.012-6.091.024-9.136-.017-.459.02-.918.006-1.378.011a.44.44,0,0,0-.5.5c-.01.564.017,1.129-.016,1.692-.014.25.055.568-.316.658-.26-.3-.167-.673-.185-1.02-.013-.271,0-.543,0-.814,0-1,0-1-.991-1.016a1.186,1.186,0,0,1-.833-.192Z",
    transform: "translate(0 -28.284)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20329",
    "data-name": "Path 20329",
    d: "M1556.585-130.505a1.2,1.2,0,0,1,.058.674q.008,7.63,0,15.26c0,.44.039.671.593.668,4.645-.027,9.291-.019,13.936-.022v6.308a1.732,1.732,0,0,1-1.2.186c-.455,0-.639.18-.626.63.015.519.01,1.038,0,1.557a.952.952,0,0,1-.164.649c-.355,0-.3-.295-.324-.494a8.9,8.9,0,0,1-.02-1.128c0-1.208,0-1.209-1.178-1.207q-.345,0-.69-.009c-2.836.039-5.672.007-8.507.017h-.567c-1.022,0-1.024,0-1.025,1q0,3.182,0,6.364c0,.252,0,.5-.016.756.024,2.05.03,4.1,0,6.151.021.481.017.962,0,1.443-.006.247.013.512-.232.681a11.318,11.318,0,0,1-.073-2.311q-.011-18.4,0-36.8C1556.55-130.257,1556.573-130.381,1556.585-130.505Z",
    transform: "translate(-333.607 -28.29)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20330",
    "data-name": "Path 20330",
    d: "M1187.466,88.154v6.21a2.664,2.664,0,0,1-2.006.021c-.646.009-1.458-.215-1.891.093s-.087,1.168-.149,1.783a.685.685,0,0,1-.065.169c-.345-.295-.21-.7-.223-1.058-.028-.816-.027-.824-.861-.839a1.654,1.654,0,0,1-.976-.149c-.5,0-1.006.023-1.5-.019-.465-.039-.553.157-.546.573a4.765,4.765,0,0,1-.055,1.487c-.268-.19-.219-.482-.221-.744-.008-1.236.044-1.147-1.178-1.149a1.072,1.072,0,0,1-.662-.147c-.665.024-1.512-.288-1.94.124-.368.354-.1,1.2-.1,1.825q-.009,10.11,0,20.22c0,.251.017.5.026.753h-.126a1.646,1.646,0,0,1-.2-1.151q-.007-10.019,0-20.038c0-.147,0-.294,0-.441,0-1.079,0-1.079-1.1-1.129a1.042,1.042,0,0,1-.71-.2V88.165a1.733,1.733,0,0,1,1.2-.187c.455,0,.637-.182.625-.631-.015-.539-.01-1.08,0-1.62a1.045,1.045,0,0,1,.165-.712c.377.026.312.337.328.557a15.578,15.578,0,0,1,.011,1.695c-.018.5.162.74.688.707a11.77,11.77,0,0,1,1.194,0c3.211-.039,6.422-.014,9.633-.012A.885.885,0,0,1,1187.466,88.154Z",
    transform: "translate(0 -215.745)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20331",
    "data-name": "Path 20331",
    d: "M1557.658,94.224q0-3.105,0-6.21a.885.885,0,0,1,.649-.187c3.208,0,6.415-.029,9.622.012.438-.018.878-.014,1.317-.007.394.007.572-.161.57-.56,0-.586-.02-1.172.011-1.757.013-.25-.055-.568.316-.659a2.877,2.877,0,0,1,.18,1.647c.026,1.241.008,1.242,1.25,1.334a.915.915,0,0,1,.583.189v6.182a1.5,1.5,0,0,1-1.025.2c-.721.027-.777.073-.786.811-.011.882,0,1.764,0,2.647q0,9.074,0,18.148a1.647,1.647,0,0,1-.2,1.151h-.126c.009-.167.026-.334.026-.5q0-10.9.013-21.795c0-.534-.154-.7-.669-.645-.458.046-.923.016-1.385.02a1.073,1.073,0,0,1-.662.147c-1.222,0-1.17-.086-1.178,1.149,0,.262.047.554-.221.744a4.773,4.773,0,0,1-.055-1.487c.007-.416-.082-.612-.546-.573-.5.042-1,.016-1.5.019a1.655,1.655,0,0,1-.976.149c-.834.015-.833.023-.861.839-.012.36.122.764-.223,1.058a4.182,4.182,0,0,1-.054-1.487c.025-.494-.154-.614-.608-.577-.478.039-.962.015-1.443.018A2.664,2.664,0,0,1,1557.658,94.224Z",
    transform: "translate(-334.592 -215.606)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20332",
    "data-name": "Path 20332",
    d: "M1177.13,53.34c-.52,0-1.04-.013-1.558.02-.381.024-.5-.1-.5-.486a18.1,18.1,0,0,0-.046-2.6,2.752,2.752,0,0,1-2.061-.053V48.072a2.717,2.717,0,0,1,2.064-.047,20.288,20.288,0,0,0,.046-2.573c0-.314.072-.458.418-.438.544.032,1.091.024,1.637.032a1.142,1.142,0,0,1,.2.831q.007,3.319,0,6.637A1.041,1.041,0,0,1,1177.13,53.34Z",
    transform: "translate(0 -180.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20333",
    "data-name": "Path 20333",
    d: "M1637.742,50.269a18.063,18.063,0,0,0-.046,2.6c0,.384-.115.511-.5.486-.518-.033-1.038-.016-1.558-.02a1.042,1.042,0,0,1-.2-.825q-.01-3.319,0-6.637a1.142,1.142,0,0,1,.2-.831c.546-.009,1.093,0,1.637-.032.346-.02.414.123.418.438a20.263,20.263,0,0,0,.046,2.573,2.717,2.717,0,0,1,2.064.047v2.145A2.752,2.752,0,0,1,1637.742,50.269Z",
    transform: "translate(-402.241 -180.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20334",
    "data-name": "Path 20334",
    d: "M1172.969,84.924a16.44,16.44,0,0,1,2.06.052c-.013.855-.047,1.71-.029,2.564.008.409-.113.558-.528.534-.5-.029-1,0-1.5,0Z",
    transform: "translate(0 -215.658)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20335",
    "data-name": "Path 20335",
    d: "M1653.158,84.976a16.319,16.319,0,0,1,2.061-.053v3.154c-.522,0-1.045-.027-1.566-.006-.359.015-.467-.12-.463-.47C1653.2,86.726,1653.171,85.851,1653.158,84.976Z",
    transform: "translate(-417.657 -215.657)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20336",
    "data-name": "Path 20336",
    d: "M1655.2,48.1a5.513,5.513,0,0,1-2.063-.047c.014-.829.05-1.658.032-2.486-.009-.418.137-.545.537-.519.5.033,1,.018,1.494.024Z",
    transform: "translate(-417.639 -180.983)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20337",
    "data-name": "Path 20337",
    d: "M1175.033,47.607a5.493,5.493,0,0,1-2.064.047V44.626c.655.017,1.486-.292,1.914.125.371.362.077,1.185.107,1.8C1175.007,46.9,1175.019,47.255,1175.033,47.607Z",
    transform: "translate(0 -180.533)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20338",
    "data-name": "Path 20338",
    d: "M1332.8,137.272c0-3.951.009-7.9-.012-11.853,0-.493.119-.625.62-.624q10.876.026,21.752,0c.473,0,.59.118.589.59q-.023,11.916,0,23.832c0,.518-.16.625-.634.608-.965-.034-1.934-.041-2.9,0-.51.023-.667-.093-.661-.637.032-2.879.02-5.758.014-8.638a12.468,12.468,0,0,0-3.785-9.287A14.212,14.212,0,0,0,1344.55,129a.615.615,0,0,0-.645.046,12.326,12.326,0,0,0-6.8,9.341,13.853,13.853,0,0,0-.136,2.2c-.015,2.879-.02,5.759.008,8.638,0,.511-.151.623-.626.605-.944-.036-1.892-.041-2.836,0-.551.025-.737-.1-.732-.7C1332.815,145.174,1332.8,141.223,1332.8,137.272Z",
    transform: "translate(-139.003 -250.344)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20339",
    "data-name": "Path 20339",
    d: "M1391.3,187.592c0,1.661-.013,3.321.01,4.982.006.415-.062.577-.533.573-3.132-.023-6.264-.016-9.4-.006-.322,0-.486-.032-.483-.427.026-3.342-.09-6.69.075-10.024a9.74,9.74,0,0,1,4.872-8.006c.262-.167.407-.057.606.071a10.078,10.078,0,0,1,4.847,8.865C1391.312,184.943,1391.3,186.268,1391.3,187.592Z",
    transform: "translate(-180.837 -293.662)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20340",
    "data-name": "Path 20340",
    d: "M1567.247,197.2c0,2.586-.007,5.172.008,7.757,0,.383-.06.538-.5.537-1.6,0-1.6.014-1.6-1.6,0-1.282.03-2.566-.038-3.845a3.058,3.058,0,0,0-3.136-2.892,3.1,3.1,0,0,0-3.048,3c-.041,1.6-.024,3.2-.007,4.793,0,.388-.067.539-.505.539-1.6,0-1.6.018-1.6-1.6,0-4.814.008-9.628-.012-14.443,0-.521.126-.666.656-.662q4.6.04,9.208,0c.466,0,.6.1.593.584C1567.233,191.982,1567.247,194.589,1567.247,197.2Z",
    transform: "translate(-333.85 -306.005)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20341",
    "data-name": "Path 20341",
    d: "M1204.887,197.113c0-2.565.011-5.13-.01-7.694,0-.466.078-.642.6-.637,3.069.028,6.139.023,9.208,0,.468,0,.646.078.644.608q-.034,7.757,0,15.515c0,.428-.1.574-.552.573-1.556-.005-1.556.013-1.557-1.56,0-1.261.024-2.523-.014-3.784a3.108,3.108,0,0,0-6.113-.644,5.414,5.414,0,0,0-.105,1.25c-.012,1.408-.016,2.817,0,4.225.005.372-.085.505-.486.511-1.615.025-1.615.04-1.615-1.557Z",
    transform: "translate(-27.753 -305.999)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20342",
    "data-name": "Path 20342",
    d: "M1344.28-8.623c-3.616,0-7.233-.009-10.849.011-.478,0-.632-.1-.627-.608q.04-4.6,0-9.209c0-.451.079-.6.573-.6q10.912.027,21.824,0c.431,0,.565.1.562.547q-.031,4.667,0,9.335c0,.473-.165.533-.575.531C1351.555-8.629,1347.918-8.623,1344.28-8.623Z",
    transform: "translate(-139.021 -125.248)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20343",
    "data-name": "Path 20343",
    d: "M1300.812-57.038q0-12.674-.016-25.347c0-.579.166-.685.7-.672,1.421.035,1.421.011,1.421,1.457q0,24.906,0,49.812c0,.922.118.814-.788.818-1.314.006-1.314,0-1.314-1.288Z",
    transform: "translate(-111.181 -69.558)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20344",
    "data-name": "Path 20344",
    d: "M1526.906-57.068q0,12.674.015,25.347c0,.589-.161.726-.723.71-1.393-.039-1.394-.012-1.394-1.425q0-24.937-.013-49.875c0-.6.087-.84.767-.808,1.346.064,1.349.018,1.349,1.4Z",
    transform: "translate(-306.005 -69.504)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20345",
    "data-name": "Path 20345",
    d: "M1344.247-48.967c-3.595,0-7.189-.01-10.784.011-.514,0-.726-.064-.7-.662.054-1.412.016-1.414,1.458-1.414,6.916,0,13.832.007,20.748-.014.581,0,.793.095.766.734-.057,1.343-.017,1.345-1.332,1.345Z",
    transform: "translate(-138.981 -97.403)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20346",
    "data-name": "Path 20346",
    d: "M1236.913,272.594c0-.777-.011-1.554,0-2.331a1.079,1.079,0,0,1,1.025-1.2,1.066,1.066,0,0,1,1.061,1.162c.024,1.554,0,3.109.013,4.663,0,.286-.072.4-.384.418-1.719.118-1.718.128-1.718-1.579Z",
    transform: "translate(-55.613 -375.826)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20347",
    "data-name": "Path 20347",
    d: "M1591,272.546c0,.777-.014,1.555.007,2.331.008.319-.074.423-.413.434-1.692.055-1.691.066-1.691-1.629,0-1.05,0-2.1,0-3.151a3.069,3.069,0,0,1,.058-.623,1,1,0,0,1,1.084-.836,1.052,1.052,0,0,1,.944,1.079c.025.8.006,1.6.006,2.394Z",
    transform: "translate(-361.766 -375.828)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20348",
    "data-name": "Path 20348",
    d: "M1462.955,79.034c0,.525-.015,1.05.006,1.574.012.313-.066.43-.412.443-1.7.064-1.7.076-1.7-1.609,0-.734.01-1.469,0-2.2-.005-.267.073-.4.353-.365a.377.377,0,0,0,.063,0c1.7-.085,1.7-.085,1.7,1.594Z",
    transform: "translate(-250.387 -208.639)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20349",
    "data-name": "Path 20349",
    d: "M1494.927,79.044c0,.546-.022,1.092.008,1.636.02.371-.12.446-.466.452-1.647.03-1.647.041-1.647-1.6,0-.692.019-1.385-.008-2.077-.014-.365.06-.508.472-.513,1.641-.02,1.641-.037,1.641,1.6Z",
    transform: "translate(-278.193 -208.721)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20350",
    "data-name": "Path 20350",
    d: "M1366.955,79.082c0,.567-.013,1.134.005,1.7.01.3-.1.382-.4.4-1.716.091-1.716.1-1.716-1.587,0-.734.014-1.469-.007-2.2-.008-.307.094-.4.394-.39a11.8,11.8,0,0,0,1.321,0c.361-.023.414.144.4.448C1366.942,77.991,1366.955,78.537,1366.955,79.082Z",
    transform: "translate(-166.887 -208.769)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20351",
    "data-name": "Path 20351",
    d: "M1332.819,79.033c0-.525.029-1.051-.009-1.573-.03-.408.128-.477.5-.48,1.617-.012,1.617-.024,1.617,1.561,0,.713-.013,1.427.006,2.14.009.329-.052.475-.437.486-1.674.046-1.673.061-1.673-1.631Z",
    transform: "translate(-139.022 -208.754)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20352",
    "data-name": "Path 20352",
    d: "M1398.958,78.841v.567c0,1.653-.167,1.789-1.826,1.541-.219-.033-.282-.112-.282-.314,0-1.175.01-2.35,0-3.525,0-.3.139-.325.381-.339,1.731-.105,1.731-.11,1.731,1.63Z",
    transform: "translate(-194.722 -208.541)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20353",
    "data-name": "Path 20353",
    d: "M1428.834,78.932c0-.546.017-1.092-.006-1.637-.014-.32.074-.426.414-.439,1.7-.064,1.7-.076,1.7,1.6,0,.713-.012,1.427.006,2.14.008.312-.065.431-.412.444-1.7.065-1.7.077-1.7-1.607Z",
    transform: "translate(-222.539 -208.631)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20354",
    "data-name": "Path 20354",
    d: "M1526.989-113.917c0,1.019,0,1.019-1,1.019-1.107,0-1.107,0-1.107-1.1,0-.967,0-.967.944-.967h.125C1526.989-114.97,1526.989-114.97,1526.989-113.917Z",
    transform: "translate(-306.089 -41.802)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20355",
    "data-name": "Path 20355",
    d: "M1236.892,156.766c.52-.007,1.041.006,1.558-.027.4-.026.491.158.48.517-.016.518.012,1.038.021,1.556a14.453,14.453,0,0,1-1.75.052c-.266.017-.31-.115-.307-.34C1236.9,157.938,1236.894,157.352,1236.892,156.766Z",
    transform: "translate(-55.599 -278.126)",
    fill: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20356",
    "data-name": "Path 20356",
    d: "M1268.343,156.818l2.006-.021q.026,1.035.053,2.07c-.039.014-.08.043-.118.039-.64-.067-1.51.322-1.863-.186C1268.115,158.28,1268.348,157.467,1268.343,156.818Z",
    transform: "translate(-82.884 -278.179)",
    fill: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20357",
    "data-name": "Path 20357",
    d: "M1557.317,156.8l2.007.021c0,.523-.038,1.049,0,1.568.038.464-.142.572-.565.535-.5-.045-1-.037-1.5-.053Q1557.29,157.832,1557.317,156.8Z",
    transform: "translate(-334.25 -278.179)",
    fill: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20358",
    "data-name": "Path 20358",
    d: "M1589.241,158.811c.009-.519.037-1.038.022-1.556-.011-.359.076-.542.48-.516.518.033,1.039.02,1.558.026a14.217,14.217,0,0,0,.006,1.506c.055.529-.166.639-.63.6S1589.72,158.828,1589.241,158.811Z",
    transform: "translate(-362.063 -278.126)",
    fill: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20359",
    "data-name": "Path 20359",
    d: "M1621.225,158.807c.01-.518.039-1.037.023-1.554-.011-.36.077-.54.48-.514.517.033,1.037.02,1.557.027,0,.1,0,.21-.005.314C1623.27,159.094,1623.27,159.094,1621.225,158.807Z",
    transform: "translate(-389.882 -278.126)",
    fill: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20360",
    "data-name": "Path 20360",
    d: "M1301.971-112.9c-1.058,0-1.058,0-1.058-1.083,0-.99,0-.99.972-.99,1.132,0,1.132,0,1.132,1.156a1.025,1.025,0,0,0,0,.188c.117.609-.132.841-.734.731A1.756,1.756,0,0,0,1301.971-112.9Z",
    transform: "translate(-111.283 -41.802)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20361",
    "data-name": "Path 20361",
    d: "M1204.908,156.766c.519-.007,1.039.006,1.557-.027.4-.026.491.156.48.515-.016.517.013,1.036.023,1.554a13.254,13.254,0,0,1-1.75.056c-.266.018-.311-.112-.308-.338C1204.918,157.939,1204.91,157.352,1204.908,156.766Z",
    transform: "translate(-27.78 -278.126)",
    fill: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20362",
    "data-name": "Path 20362",
    d: "M1204.923,53.4l0-8.293c3.3-.006,6.593-.009,9.889-.025.35,0,.477.1.474.465-.02,2.624-.022,5.249-.031,7.873Z",
    transform: "translate(-27.793 -181.014)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20363",
    "data-name": "Path 20363",
    d: "M1567.785,45.11l0,8.294-10.336.019c-.008-2.624-.011-5.249-.031-7.873,0-.361.125-.466.474-.465C1561.192,45.1,1564.489,45.1,1567.785,45.11Z",
    transform: "translate(-334.387 -181.014)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20364",
    "data-name": "Path 20364",
    d: "M1350.158,141.053c.969,0,.969,0,.969.981,0,1.081,0,1.081-1.059,1.081-1,0-1,0-1-1.015C1349.065,141.053,1349.065,141.053,1350.158,141.053Z",
    transform: "translate(-153.164 -264.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20365",
    "data-name": "Path 20365",
    d: "M1478.076,143.115c-1.023,0-1.023,0-1.023-.992,0-1.07,0-1.07,1.069-1.07.993,0,.993,0,.993,1.022C1479.115,143.115,1479.115,143.115,1478.076,143.115Z",
    transform: "translate(-264.485 -264.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20366",
    "data-name": "Path 20366",
    d: "M1358.483-3.187c2.9,0,5.8.01,8.7-.01.472,0,.608.129.6.6-.027,1.7-.02,3.4,0,5.105,0,.406-.067.6-.541.6q-8.824-.022-17.649,0c-.411,0-.541-.121-.536-.538.021-1.723.026-3.446,0-5.168-.008-.483.147-.6.609-.593C1352.6-3.177,1355.542-3.187,1358.483-3.187Z",
    transform: "translate(-153.151 -139.019)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20367",
    "data-name": "Path 20367",
    d: "M1223.1,69.989c0,1.026,0,1.026-1.044,1.026-1.029,0-1.029,0-1.029-1.044s0-1.046,1.053-1.046C1223.1,68.924,1223.1,68.924,1223.1,69.989Z",
    transform: "translate(-41.797 -201.749)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20368",
    "data-name": "Path 20368",
    d: "M1254.031,71.015c-.992,0-.992,0-.992-1.017,0-1.074,0-1.074,1.085-1.074.985,0,.985,0,.985.974v.063C1255.109,71.015,1255.109,71.015,1254.031,71.015Z",
    transform: "translate(-69.643 -201.749)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20369",
    "data-name": "Path 20369",
    d: "M1606.07,68.924c1.011,0,1.011,0,1.011,1.026,0,1.065,0,1.065-1.071,1.065-1,0-1,0-1-1.005C1605.008,68.924,1605.008,68.924,1606.07,68.924Z",
    transform: "translate(-375.777 -201.749)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20370",
    "data-name": "Path 20370",
    d: "M1574.082,68.924c1.009,0,1.009,0,1.009,1.025,0,1.066,0,1.066-1.068,1.066-1,0-1,0-1-1C1573.021,68.924,1573.021,68.924,1574.082,68.924Z",
    transform: "translate(-347.955 -201.749)",
    fill: "#020202"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMumbai);
export default __webpack_public_path__ + "static/media/mumbai.c40242bf0fe09d6e10dfc33483804c87.svg";
export { ForwardRef as ReactComponent };